<template>
  <v-container fluid>
    <v-layout>
      <video-component />
    </v-layout>
  </v-container>
</template>

<script>
import VideoComponent from '@/components/VideoComponent.vue';

export default {
  name: 'Video',
  components: {
    VideoComponent,
  },
};

</script>

<style scoped></style>
